// material-ui
'use client'

import { getUniversityName } from "@/app/global-functions/getUniversityName";
import { useEffect, useState } from "react";
import { useSelector } from "@/app/store";
import Image from 'next/image';

const Logo = () => {
  const [abreviaturaUniversidade, setabreviaturaUniversidade] = useState("");
  const [university, setUniversity] = useState(getUniversityName());
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);
  const [language, setLanguage] = useState("fr");

  useEffect(() => {
    const fetchUniversity = async () => {
        const universityData = await getUniversityName();
        setUniversity(universityData);
        setabreviaturaUniversidade(universityData.abreviatura);
    };

    fetchUniversity();
  }, []);

  useEffect(() => {
    paramMemoire.forEach((item) => {
      setLanguage(item.langueReport);
    });
  }, [paramMemoire]);

  return (
    <div>
      {abreviaturaUniversidade === "ISPOZANGO" && (
        <Image
          src="/images/ispozango/logoispo.jpg"
          alt="ISP Logo"
          width={80}
          height={80}
          unoptimized
        />
      )}

      {abreviaturaUniversidade === "FUTURISS" && (
        <Image
          src="/images/FUTURISSplusSlogan-05.PNG"
          alt="FUTURISS Logo"
          width={70}
          height={70}
          unoptimized
        />
      )}

      {abreviaturaUniversidade === "UNIKIN" && (
        <Image
          src="/images/UNIKIN/logoUnikin.jpeg"
          alt="UNIKIN Logo"
          width={60}
          height={60}
          unoptimized
        />
      )}

      {abreviaturaUniversidade === "LECARTESIEN" && (
        <Image
          src="/images/lesCartesiens/Image1.png"
          alt="LE CARTESIEN Logo"
          width={60}
          height={60}
          unoptimized
        />
      )}

      {abreviaturaUniversidade === "UCAN" && (
        <Image
          src="/images/ucan/ucanlogo.jpg"
          alt="UCAN Logo"
          width={60}
          height={60}
          unoptimized
        />
      )}

      {abreviaturaUniversidade === "SIERASCHOOLS" && (
        <Image
          src="/images/sieraschools/logo.jpg"
          alt="SIERA SCHOOLS Logo"
          width={60}
          height={60}
          unoptimized
        />
      )}

      {abreviaturaUniversidade === "IDERO" && (
        <Image
          src="/images/idero/logo.jpg"
          alt="IDERO Logo"
          width={50}
          height={50}
          unoptimized
        />
      )}

      {/* Default Image if no abbreviation matches */}
      {(!abreviaturaUniversidade || abreviaturaUniversidade === "") && (
        <Image
          src="/images/FUTURISSplusSlogan-05.PNG"
          alt="Default Logo"
          width={80}
          height={80}
          unoptimized
        />
      )}
    </div>
  );
};

export default Logo;